<template>
  <div id="hero">
    <div class="head">
      <h3>
        Get delicious food from your favourite restaurants delivered to your
        door step.
      </h3>
      <p class="info">*Presently available to Makurdi residents.</p>
    </div>
    <div class="hero">
      <a
        href="https://play.google.com/store/apps/details?id=com.ccr.mealtrips"
        target="_blank"
        ><button class="store">
          <Icons name="playstore" />
          <div class="text">
            Download the app on <br />
            <span>Google Play</span>
          </div>
        </button></a
      >
    </div>
  </div>
</template>

<script>
import Icons from "./Icons.vue";

export default {
  name: "Hero",
  components: {
    Icons,
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap");

#hero {
  height: 150vh;
  background: url("../assets/hero.png");
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10%;
  a:hover {
    text-decoration: none;
  }
  .head {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    h3 {
      font-family: "Abril Fatface", cursive;
      font-size: 48px;
      line-height: 56px;
      width: 688px;
      color: #165049;
    }
    .info {
      color: #a13216;
      font-size: 24px;
      font-weight: 500;
    }
  }
  .hero{
    .store {
      background: #030607;
      font-family: "Raleway", sans-serif;
      display: flex;
      align-items: center;
      padding: 16px 32px;
      border: none;
      border-radius: 48px;
      margin: auto;
      margin-top: 36px;
      .text {
        color: #fefefe;
        font-size: 14px;
        margin-left: 24px;
        span {
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
    }
}

@media (max-width: 480px) {
  #hero {
    background-size: 100%;
    height: auto;
    background: none;
    background-position: bottom;
    position: relative;
    .head {
      width: 100%;
      padding: 8%;
      padding-top: 30%;
      background: #fff;
      h3 {
        font-size: 28px;
        line-height: 35px;
        text-align: center;
        width: 100%;
        color: #165049;
      }
      .info {
        color: #a13216;
        font-size: 18px;
        width: 100%;
        font-weight: 500;
      }
    }
  .hero{ 
      background: url("../assets/svg/mobileback.svg") no-repeat;
      width: 100%;
      height: 100%;
      background-size: 100%;
      .store {
        background: #030607;
        font-family: "Raleway", sans-serif;
        display: flex;
        align-items: center;
        padding: 8px 16px;
        border: none;
        border-radius: 48px;
        margin: auto;
        margin-top: 36px;
        margin-bottom: 40%;
        .text {
          color: #fefefe;
          font-size: 12px;
          margin-left: 14px;
          span {
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
  }
  }
}

@media (min-width: 481px) and (max-width: 768px){
    #hero {
    background-size: 100%;
    height: auto;
    background: none;
    background-position: bottom;
    position: relative;
    .head {
      width: 100%;
      padding: 8%;
      padding-top: 30%;
      background: #fff;
      h3 {
        font-size: 28px;
        line-height: 35px;
        text-align: center;
        width: 80%;
        color: #165049;
      }
      .info {
        color: #a13216;
        font-size: 18px;
        width: 80%;
        font-weight: 500;
      }
    }
  .hero{ 
      background: url("../assets/svg/mobileback.svg") no-repeat;
      width: 100%;
      height: 100%;
      background-size: 100%;
      .store {
        background: #030607;
        font-family: "Raleway", sans-serif;
        display: flex;
        align-items: center;
        padding: 8px 16px;
        border: none;
        border-radius: 48px;
        margin: auto;
        margin-top: 36px;
        margin-bottom: 50%;
        .text {
          color: #fefefe;
          font-size: 12px;
          margin-left: 14px;
          span {
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
  }
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
    #hero {
    background-size: 100%;
    height: auto;
    background: none;
    background-position: bottom;
    position: relative;
    .head {
      width: 100%;
      padding: 8%;
      padding-top: 20%;
      background: #fefefe;
      border: none;
      h3 {
        text-align: center;
        width: 80%;
        color: #165049;
      }
      .info {
        color: #a13216;
        font-size: 24px;
        width: 80%;
        font-weight: 500;
      }
    }
  .hero{ 
      background: url("../assets/svg/mobileback.svg") no-repeat;
      width: 100%;
      height: 100%;
      border: none;
      background-size: 100%;
      .store {
        background: #030607;
        font-family: "Raleway", sans-serif;
        display: flex;
        align-items: center;
        padding: 10px 18px;
        border: none;
        border-radius: 48px;
        margin: auto;
        margin-top: 36px;
        margin-bottom: 60%;
        .text {
          color: #fefefe;
          font-size: 14px;
          margin-left: 14px;
          span {
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
  }
  }
}
</style>